import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../lib/store';
import { RefreshCwIcon, WalletIcon, StarIcon, GlobeIcon, HelpCircleIcon, ChevronRightIcon, LogOutIcon } from 'lucide-react';
interface AccountMenuListProps {
  onLanguageClick?: () => void;
}
export function AccountMenuList({
  onLanguageClick
}: AccountMenuListProps) {
  const navigate = useNavigate();
  const {
    language
  } = useStore();
  const menuItems = [{
    icon: GlobeIcon,
    label: `Language (${language === 'ar' ? 'Arabic' : 'English'})`,
    action: 'language',
    showArrow: true
  }, {
    icon: HelpCircleIcon,
    label: 'Help and Support',
    path: '/help-center',
    showArrow: true
  }];
  const handleItemClick = (item: any) => {
    if (item.action === 'language' && onLanguageClick) {
      onLanguageClick();
    } else if (item.path) {
      navigate(item.path);
    }
  };
  return <div className="bg-white" data-id="element-256" data-mp="3mf9neyuqxb0a">
      {/* Menu Items */}
      <div className="px-4 py-2" data-id="element-257" data-mp="3qgl7fzuwwsuo">
        {menuItems.map((item, index) => {
        const Icon = item.icon;
        return <button key={index} onClick={() => handleItemClick(item)} className="w-full flex items-center justify-between py-4 border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors" data-id="element-258" data-mp="3uhx3oo8akcbu" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-259" data-mp="36scevopgikun">
                <Icon className="w-5 h-5 text-gray-600" data-id="element-260" data-mp="36uypjx7n9gh3" />
                <span className="text-sm font-medium text-gray-900" data-id="element-261" data-mp="3bt04c5y1etmr">
                  {item.label}
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-262" data-mp="2xu8syrak7m2b">
                {item.showArrow && <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-263" data-mp="32td61t0lu3xx" />}
              </div>
            </button>;
      })}
      </div>
      {/* Sign Out Button */}
      <div className="px-4 py-4 bg-red-50" data-id="element-264" data-mp="10z4c654rohpk">
        <button onClick={() => {
        // Handle sign out
        console.log('Sign out');
      }} className="w-full flex items-center justify-center gap-2 py-3 text-red-600 font-semibold hover:text-red-700 transition-colors" data-id="element-265" data-mp="ylqswnepgl21">
          <LogOutIcon className="w-5 h-5" data-id="element-266" data-mp="pmdrmi0qj2se" />
          <span data-id="element-267" data-mp="km978gwphnww">Sign Out</span>
        </button>
      </div>
    </div>;
}